import { DevicesDashboardFilters, DevicesDashboardTable } from "modules/DevicesDashboard/components";

export const DevicesDashboard = () => (
  <>
    <DevicesDashboardFilters />
    <DevicesDashboardTable />
  </>
);
